import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useCampaignClearEffects from '../useCampaignClearEffects'
import usePermissions from '../../../../hooks/usePermissions'

import { insertIf } from '../../../../helpers/common'

import { openForm } from '../../../../modules/actions/forms'
import { updateCampaign } from '../../../../modules/actions/campaigns'
import { selectedGoogleAdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { CAMPAIGN_GOOGLE_EDIT, CHANGE_CAMPAIGN_HISTORY } from '../../../../constants/forms'
import { listItemChangeStatus } from '../../../../constants/other'
import { GOOGLE_PLATFORM } from '../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../constants/changeHistory'

const useGetGoogleCampaignActions = () => {
  const dispatch = useDispatch()

  const permissions = usePermissions()

  const { id: googleAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  useCampaignClearEffects()

  return useCallback(
    ({ id, status }) => {
      return [
        ...insertIf(
          permissions.can('update', 'Campaign'),
          {
            text: 'Edit',
            onClickHandler: () => dispatch(openForm({ id, formName: CAMPAIGN_GOOGLE_EDIT }))
          },
          ...insertIf(permissions.can('update', 'Campaign'), {
            text: status === 'active' ? 'Pause' : 'Activate',
            onClickHandler: () => {
              dispatch(
                updateCampaign(
                  {
                    status: listItemChangeStatus[status].changeTo,
                    account: googleAdAccountId,
                    meta: {
                      [HISTORY_META_EDIT_SECTION]: 'Status'
                    }
                  },
                  id,
                  GOOGLE_PLATFORM
                )
              )
            }
          }),

          {
            text: 'Change History',
            onClickHandler: () => dispatch(openForm({ id, formName: CHANGE_CAMPAIGN_HISTORY }))
          }
        )
      ]
    },
    [dispatch, googleAdAccountId, permissions]
  )
}

export default useGetGoogleCampaignActions
